<template>
    <div>
        <modal
            :is-open="isOpen"
            :is-loading="loading"
            :disabled="loading"
            :btn-save-title="btnSaveTitle"
            :btn-save-classes="['cabinet-btn--pink']"
            :title="title"
            @onCloseModal="closeModal"
            @onSaveModal="saveModal"
        >
            <template v-if="access.Status === statuses.new">
                Запрос на доступ от ритейлера
                <span class="text-bold">{{
                    access.retailer ? access.retailer.company_name : ''
                }}</span>
                будет отклонен.
            </template>
            <template v-else>
                Ритейлеру
                <span class="text-bold">{{
                    access.retailer ? access.retailer.company_name : ''
                }}</span>
                будет закрыт доступ к изделиям с ограниченным доступом.
            </template>
        </modal>
    </div>
</template>

<script>
import Modal from '@/components/Elements/Modal'
import { mapState, mapActions } from 'vuex'

export default {
    name: 'RejectModal',
    components: { Modal },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        access: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: false
        }
    },
    computed: {
        ...mapState('supplierAccessControl', ['statuses', 'errors']),
        title() {
            if (this.access.Status === this.statuses.new)
                return 'Отклонить запрос?'
            return 'Закрыть доступ?'
        },
        btnSaveTitle() {
            if (this.access.Status === this.statuses.new)
                return 'Отклонить запрос'
            return 'Закрыть доступ'
        },
        notification() {
            if (this.access.Status === this.statuses.new)
                return 'Запрос отклонен'
            return 'Доступ закрыт'
        }
    },
    methods: {
        ...mapActions('supplierAccessControl', ['rejectAccess']),
        closeModal() {
            this.$emit('closeModal')
        },
        async saveModal() {
            if (this.loading) return

            this.loading = true

            try {
                await this.rejectAccess(this.access.BrandItemsAccessID)

                this.$notify({
                    title: this.notification,
                    type: 'success'
                })

                this.$emit('rejectModalSaved')
            } catch (e) {
                console.log(e)
                this.$notify({
                    title: 'Ошибка',
                    type: 'error'
                })
            }

            this.loading = false
        }
    }
}
</script>
